/** @format */
/* TODO - rebuild this in Chakra and new styling. (Unless LeaseManager or HubSpot or something else lets us remove this entirely.) */
/* TODO - clean up TypeScript, remove as many ts-ignore and :any as we can. */
/* TODO - extract any common pieces to share with other forms?. */

import React, { useState } from "react";
import { withFormik, Field, FormikProps } from "formik";
// @ts-ignore
import { sendError } from "../components/Analytics";
// @ts-ignore
import { API_BASE_API } from "../OldApp";
// @ts-ignore
import FileUploadButton from "../components/old-site/FileUploadButton";
import Select, { components, StylesConfig } from "react-select";
// @ts-ignore
import useFetchJson from "../hooks/useFetchJson";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { absoluteUrl } from "../components/Utils";
import { Box, Card, CardBody, Container } from "@chakra-ui/react";
// @ts-ignore
import { animateScroll } from "react-scroll";
import AbsoluteLoadingOverlay from "../components/AbsoluteLoadingOverlay";

function toBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (!reader.result) {
        reject("failed to read attachment");
        return;
      }
      let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    reader.onerror = (error) => reject(error);
  });
}
const notListedOption = {
  value: "OTHER",
  label: "Other / Not Listed",
  labelLong: "Other / Not Listed",
};

type TenantInfoFormValues = any;
interface TenantInfoFormPageProps {
  mode: "New Tenant" | "Tenant Contact" | "Tenant Contact Commercial Cafe";
}
interface TenantInfoFormProps extends TenantInfoFormPageProps {
  captureResult: React.Dispatch<React.SetStateAction<string | undefined>>;
  submissionResult: string | undefined;
}
interface TenantInfoFormWrapperProps extends TenantInfoFormPageProps {}

// control height 40px here to match the rest of the form (different from 50px on ContactForm2)
const inputHeight = "40px";
const inputBorderRadius = "0.5rem";
const selectCustomStyles = (props: any) => {
  // noinspection JSUnusedGlobalSymbols // Not sure why IDEA thinks these object keys are unused globals
  const customStyles: StylesConfig = {
    multiValueLabel: (base) => ({ ...base, color: "#3697B5" }),
    menu: (base) => ({ ...base, marginTop: "2px" }),
    menuList: (base) => ({ ...base, paddingTop: "0", paddingBottom: "0" }),
    control: (base) => ({
      ...base,
      height: inputHeight,
      borderRadius: inputBorderRadius,
      borderColor: props.error && props.touched ? "red" : "#032845",
    }),
  };
  return customStyles;
};
const AddressSelect = (props: any) => {
  const handleChange = (value: any) => {
    // this is going to call setFieldValue and manually update values.suite
    props.onChange("property_wtweb_id", value);
    props.setOtherPicked((value.value || value) === "OTHER");
  };

  const handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.suite
    props.onBlur("property_wtweb_id", true);
    //props.setOtherPicked((value.value || value) === "OTHER");
  };

  const customStyles = selectCustomStyles(props);

  return (
    <div
      className="contactFormInput"
      key={"property_wtweb_id"}
      style={{ flexGrow: 2, padding: "0px 8px" }}
    >
      <label htmlFor="property_wtweb_id" className={"label-required"}>
        Office Address
      </label>
      <Select
        id="property_wtweb_id"
        options={[notListedOption].concat(props.options)}
        onChange={handleChange}
        onBlur={handleBlur}
        value={props.value}
        components={{
          Option: (props: any) => (
            <components.Option {...props}>
              {props.data.labelLong}
            </components.Option>
          ),
          NoOptionsMessage: (props: any) => (
            <components.NoOptionsMessage {...props}>
              No available addresses
            </components.NoOptionsMessage>
          ),
        }}
        className={props.error && props.touched ? " error" : ""}
        styles={customStyles}
      />
      {(props.error && props.touched && (
        <div
          className="input-feedback"
          style={{
            color: "#dd2b0e",
            fontSize: "13px",
            paddingTop: "4px",
            fontWeight: "500",
          }}
        >
          {props.error}
        </div>
      )) ||
        null}
    </div>
  );
};

const SuiteSelect = (props: any) => {
  const handleChange = (value: any) => {
    // this is going to call setFieldValue and manually update values.suite
    props.onChange("suite_number", value);
    props.setOtherPicked((value.value || value) === "OTHER");
  };

  const handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.suite
    props.onBlur("suite_number", true);
    //props.setOtherPicked((value.value || value) === "OTHER");
  };

  const customStyles = selectCustomStyles(props);

  return (
    <div
      className="contactFormInput"
      key={"suite_number"}
      style={{ flexGrow: 2, padding: "0px 8px" }}
    >
      <label htmlFor={"suite_number"} className={"label-required"}>
        Suite Number
      </label>
      <Select
        id="suite_number"
        options={[notListedOption].concat(props.options)}
        onChange={handleChange}
        onBlur={handleBlur}
        value={props.value}
        components={{
          NoOptionsMessage: (props: any) => (
            <components.NoOptionsMessage {...props}>
              No available suites
            </components.NoOptionsMessage>
          ),
        }}
        className={props.error && props.touched ? " error" : ""}
        styles={customStyles}
      />
      {(props.error && props.touched && (
        <div
          className="input-feedback"
          style={{
            color: "#dd2b0e",
            fontSize: "13px",
            paddingTop: "4px",
            fontWeight: "500",
          }}
        >
          {props.error}
        </div>
      )) ||
        null}
    </div>
  );
};

const addressToSelectOption = (a: any) => ({
  value: a.id,
  label:
    _.trim(
      `${a.externalName || ""} ${a.address || ""} ${a.city || ""}, ${
        a.state || ""
      } ${a.zip || ""}`,
      ", ",
    ) || a.id,
  labelLong:
    _.trim(
      `${a.externalName || ""} ${a.address || ""} ${a.city || ""}, ${
        a.state || ""
      } ${a.zip || ""}`,
      ", ",
    ) || a.id,
});

const TenantInfoForm = (
  props: TenantInfoFormProps & FormikProps<TenantInfoFormValues>,
) => {
  const {
    values,
    touched,
    errors,
    //dirty,
    isSubmitting,
    handleSubmit,
    //handleReset,
    setFieldValue,
    setFieldTouched,
  } = props;

  let [acceptedLogos, setAcceptedLogos] = useState([]);
  let [checkinFrequencyOther, setCheckinFrequencyOther] = useState(false);
  const { data: allAddresses } = useFetchJson(`/all_addresses.json`);
  const [showOtherAddressField, setShowOtherAddressField] = useState(false);
  const [showOtherSuiteField, setShowOtherSuiteField] = useState(false);

  const propertySuites = values.property_wtweb_id?.value
    ? allAddresses?.find((a: any) => a.id === values.property_wtweb_id.value)
        ?.suiteNumbers
    : [];

  const Errors = ({ id, ...props }: any) =>
    (props.errors[id] && props.touched[id] && (
      <div
        className="input-feedback"
        style={{
          color: "#dd2b0e",
          fontSize: "13px",
          paddingTop: "4px",
          fontWeight: "500",
        }}
      >
        {props.errors[id]}
      </div>
    )) ||
    null;
  const FormInputRow = (inputs: any, key: React.Key) => {
    return (
      <div
        key={key}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        {inputs.map((m: any) => {
          if (!m) return null;
          switch (m.type) {
            case "contactCheckinFrequency":
              return ContactCheckinFrequencyInputs(m);
            case "contactCheckboxes":
              return ContactCheckboxesInput(m);
            case "select":
              return SelectInput(m);
            case "component":
              return m.component;
            default:
              return TextInput(m);
          }
        })}
      </div>
    );
  };
  const TextInput = (m: any) => (
    /* For some reason, calling this as <TextInput> blurs after each char, but calling as a function in {} works fine? */

    <div
      className="contactFormInput"
      key={m.id}
      style={{ flexGrow: 2, padding: "0px 8px" }}
    >
      <label htmlFor={m.id} className={m.required ? "label-required" : ""}>
        {m.label}
      </label>
      <Field type="text" name={m.id} placeholder={m.placeholder}>
        {({ field, form }: any) => (
          <input
            style={{
              height:
                inputHeight /* TODO - move this to CSS so it applies to the Select too?*/,
              borderRadius: inputBorderRadius,
            }}
            type="text"
            {...field}
            {...(m.disabled ? { disabled: "disabled" } : {})}
            {...(m.required ? { required: "required" } : {})}
            className={
              form.errors[m.id] && form.touched[m.id]
                ? "text-input error"
                : "text-input"
            }
          />
        )}
      </Field>
      <Errors id={m.id} {...props} />
    </div>
  );
  const ContactCheckboxesInput = (b: any) => (
    /* For some reason, calling this as <TextInput> blurs after each char, but calling as a function in {} works fine? */
    <div
      key={"contact_checkboxes"}
      style={{ marginLeft: "24px", marginBottom: "2rem" }}
    >
      <h4 className="">This contact:</h4>
      {b.items.map((m: any) => (
        <div
          className="contactFormCheckbox"
          key={m.id}
          style={{ flexGrow: 2, padding: "0px 8px" }}
        >
          <Field type="checkbox" name={m.id} placeholder={m.placeholder}>
            {({ field, form }: any) => (
              <input
                type="checkbox"
                {...field}
                className={
                  form.errors[m.id] && form.touched[m.id]
                    ? "text-input error"
                    : "text-input"
                }
              />
            )}
          </Field>
          <label
            htmlFor={m.id}
            className={m.required ? "label-required" : ""}
            style={{ margin: "0px 8px" }}
          >
            {m.label}
          </label>
          <Errors id={m.id} {...props} />
        </div>
      ))}
    </div>
  );
  const ContactCheckinFrequencyInputs = (b: any) => (
    <React.Fragment key={"checkin_freq"}>
      {SelectInput({
        id: "primary_contact_checkin_frequency",
        required: true,
        type: "select",
        options: ["1x Month", "1x Quarter", "2x Year", "1x Year", "Other"],
        label: "Preferred Check-In Frequency",
        changeCallback: (value: any) => {
          setFieldValue("primary_contact_checkin_frequency_other", "");
          setCheckinFrequencyOther(value?.value === "Other");
        },
      })}
      {checkinFrequencyOther &&
        TextInput({
          id: "primary_contact_checkin_frequency_other",
          placeholder: "Other",
          label: "Other",
          disabled: !checkinFrequencyOther,
          required: checkinFrequencyOther,
        })}
    </React.Fragment>
  );

  const SelectInput = (m: any) => {
    const handleChange = (value: any) => {
      // this is going to call setFieldValue and manually update values.suite
      setFieldValue(m.id, value);
      if (m.changeCallback) m.changeCallback(value);
    };

    const handleBlur = () => {
      // this is going to call setFieldTouched and manually update touched.suite
      setFieldTouched(m.id, true);
    };

    const customStyles = selectCustomStyles(m);

    return (
      <div
        className="contactFormInput"
        key={m.id}
        style={{ flexGrow: 2, padding: "0px 8px" }}
      >
        <label htmlFor={m.id} className={m.required ? "label-required" : ""}>
          {m.label}
        </label>
        <Select
          id={m.id}
          options={m.options.map((s: any) => ({ value: s, label: s }))}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values[m.id]}
          components={{
            NoOptionsMessage: (props: any) => (
              <components.NoOptionsMessage {...props}>
                No available options
              </components.NoOptionsMessage>
            ),
          }}
          className={errors[m.id] && touched[m.id] ? " error" : ""}
          styles={customStyles}
        />
        {(errors[m.id] && touched[m.id] && (
          <div
            className="input-feedback"
            style={{
              color: "#dd2b0e",
              fontSize: "13px",
              paddingTop: "4px",
              fontWeight: "500",
            }}
          >
            {errors[m.id] as string}
          </div>
        )) ||
          null}
      </div>
    );
  };

  const fillFake = () => {
    if (!process.env.REACT_APP_STAGE_LABEL) return;
    const fakeValues: any = {
      tenant_name: "Phil Fake Tenant Name",
      suite_number: "suite num",
      business_name: "business name",
      employee_count: "emp count",
      business_hours_days: "9 to 5",
      office_phone: "555-555-5551",
      fax_number: "555-555-9999",
      website_inbox: "WebbyGeneralInbox",
      alarm_system_code: "12345",
      direct_back_line: "555-867-5309",
      primary_contact_first_name: "Primrose",
      primary_contact_last_name: "Constant",
      primary_contact_phone: "555-555-5552",
      primary_contact_email: "prim.mary@email.my",
      primary_contact_discuss_lease: true,
      primary_contact_discuss_balance: true,
      primary_contact_approve_chargebacks: true,
      primary_contact_receive_memos: true,
      primary_contact_tenant_survey: true,
      primary_contact_portal_user: true,
      secondary_contact_first_name: "Gary",
      secondary_contact_last_name: "Secundo",
      secondary_contact_phone: "555-555-5553",
      secondary_contact_email: "garysegundo@email.my",
      secondary_contact_discuss_lease: true,
      secondary_contact_discuss_balance: true,
      secondary_contact_approve_chargebacks: true,
      secondary_contact_receive_memos: true,
      secondary_contact_tenant_survey: true,
      secondary_contact_portal_user: true,
      emergency_contact_1_first_name: "Connie",
      emergency_contact_1_last_name: "Mergens",
      emergency_contact_2_first_name: "Halp",
      emergency_contact_2_last_name: "Mei",
      emergency_contact_3_first_name: "Needsom",
      emergency_contact_3_last_name: "Sistance",
      emergency_contact_1_phone: "555-555-9111",
      emergency_contact_2_phone: "555-555-9112",
      emergency_contact_3_phone: "555-555-9113",
      emergency_contact_1_email: "emerg1@email.my",
      emergency_contact_2_email: "emerg2@email.my",
      emergency_contact_3_email: "emerg3@email.my",
      primary_billing_contact_first_name: "William",
      primary_billing_contact_last_name: "Primbly",
      primary_billing_contact_phone: "555-555-5511",
      primary_billing_contact_email: "primarybill@email.my",
      primary_billing_contact_mailing_address: "123 fake st",
      primary_billing_contact_mailing_address_city: "Boca Raton",
      primary_billing_contact_mailing_address_state: "FL",
      primary_billing_contact_mailing_address_zip: "22222",
      additional_billing_contact_first_name: "Bill",
      additional_billing_contact_last_name: "Secondarino",
      additional_billing_contact_email: "secondbill@email.my",
    };
    const newTenantFakeValues: any = {
      key_request_suite_master: "1",
      key_request_front_door_only: "2",
      key_request_mailbox: "3",
      key_request_office: "4",
      key_request_access_card: "5",
      key_request_location_of_other: "under rock in garden",
      welcome_board_practice_information:
        "here's a story\n of a lovely lady\nwho was living with ",
      welcome_board_name: "welcome george sanderson",
      welcome_board_email: "welcome@bored.email",
    };

    // These fields are hidden in the CC version of the form. Once we're done with this conversion, these fields can go back into fakeValues.
    const nonCCFakeValues: any = {
      executive_contact_first_name: "Exxic",
      executive_contact_last_name: "Utive",
      executive_contact_phone: "555-555-5556",
      executive_contact_email: "steakknifes@second.place",
      executive_contact_mailing_address: "Top of the Rock",
      executive_contact_mailing_address_city: "New York",
      executive_contact_mailing_address_state: "NY",
      executive_contact_mailing_address_zip: "11111",
      insurance_contact_first_name: "Farmer",
      insurance_contact_last_name: "Simmons",
      insurance_contact_phone: "555-555-5557",
      insurance_contact_email: "bumbabumbum@bumbum.bum",
      insurance_contact_mailing_address: "13 Lucky Blvd",
      insurance_contact_mailing_address_city: "Durham",
      insurance_contact_mailing_address_state: "TX",
      insurance_contact_mailing_address_zip: "33333",
      directory_board_name: "Directly Bored",
    };

    Object.keys(fakeValues).forEach((k) =>
      setFieldValue(k, fakeValues[k], false),
    );

    if (props.mode === "New Tenant") {
      Object.keys(newTenantFakeValues).map((k) =>
        setFieldValue(k, newTenantFakeValues[k], false),
      );
    }

    if (props.mode !== "Tenant Contact Commercial Cafe") {
      Object.keys(nonCCFakeValues).forEach((k) =>
        setFieldValue(k, nonCCFakeValues[k], false),
      );
    }
    let filteredAddresses = (allAddresses || []).filter(
      (ao: any) => ao.id === "550-heritage-drive",
    );

    let pickedAddress =
      filteredAddresses && filteredAddresses.length && filteredAddresses[0];
    if (pickedAddress) {
      setFieldValue("property_wtweb_id", addressToSelectOption(pickedAddress));
      let pickedSuite =
        pickedAddress.suiteNumbers &&
        pickedAddress.suiteNumbers.length > 1 &&
        pickedAddress.suiteNumbers[1];
      if (pickedSuite) {
        setFieldValue("suite_number", {
          value: pickedSuite,
          label: pickedSuite,
        });
      }
    }
    const otherPickers: any = {
      primary_contact_checkin_method: "In Person",
      primary_contact_checkin_frequency: "1x Quarter",
    };
    Object.keys(otherPickers).forEach((k) => {
      // I thought setting by just the value string worked, but it wasn't (maybe our weird hacks to get react-select in formik?)
      setFieldValue(k, { value: otherPickers[k], label: otherPickers[k] });
    });
  };

  if (props.submissionResult) {
    animateScroll.scrollToTop();
  }

  return (
    <div className="contactForm contactformtwoWrapper">
      {process.env.REACT_APP_STAGE_LABEL && !props.submissionResult && (
        <button
          className="textButton bk-button"
          onClick={fillFake}
          style={{ float: "right" }}
        >
          Fill Fake
        </button>
      )}
      <h1 className="form-header">
        Welltower{" "}
        {props.mode === "New Tenant"
          ? "New Tenant Form"
          : "Tenant Contact Form "}
        {["DEV", "LOCAL"].includes(process.env.REACT_APP_STAGE_LABEL!) &&
          props.mode === "Tenant Contact Commercial Cafe" && (
            <span style={{ color: "#f48a3d" }}>CC variation</span>
          )}
      </h1>

      {props.submissionResult && <p>{props.submissionResult}</p>}
      {!props.submissionResult && (
        <form className="newTenantForm" onSubmit={handleSubmit}>
          <Field
            type="hidden"
            name={"new_tenant_form"}
            value={props.mode !== "New Tenant"}
          />
          <Field
            type="hidden"
            name={"commercial_cafe_form"}
            value={props.mode !== "Tenant Contact Commercial Cafe"}
          />
          <div className="new-tenant-form-section-container">
            <div className="new-tenant-form-section-column ">
              <h1 className="new-tenant-form-section-title">
                Contact Information
              </h1>
              <div className="new-tenant-form-body">
                <AddressSelect
                  value={values.property_wtweb_id}
                  options={(allAddresses || []).map(addressToSelectOption)}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  error={errors.property_wtweb_id}
                  touched={touched.property_wtweb_id}
                  setOtherPicked={(b: any) => {
                    setShowOtherAddressField(b);
                    if (b) {
                      setFieldValue("suite_number", notListedOption);
                      setShowOtherSuiteField(b);
                    }
                  }}
                />

                {[
                  showOtherAddressField
                    ? [
                        {
                          id: "address_other",
                          required: showOtherAddressField,
                          placeholder: "Office Address",
                          label: "Other Address",
                        },
                      ]
                    : [],
                  [
                    {
                      id: "tenant_name",
                      required: true,
                      placeholder: "Name",
                      label: "Tenant Name",
                    },
                    {
                      type: "component",
                      component: (
                        <SuiteSelect
                          key={"suite_number"}
                          value={values.suite_number}
                          options={(propertySuites || []).map((s: any) => ({
                            value: s,
                            label: s,
                          }))}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          error={errors.suite_number}
                          touched={touched.suite_number}
                          setOtherPicked={setShowOtherSuiteField}
                        />
                      ),
                    },
                    showOtherSuiteField
                      ? {
                          id: "suite_number_other",
                          required: true,
                          placeholder: "Suite",
                          label: "Suite Number",
                        }
                      : undefined,
                  ],
                  [
                    {
                      id: "business_name",
                      required: true,
                      placeholder: "Business",
                      label: "Business Name",
                    },
                  ],
                  [
                    {
                      id: "employee_count",
                      required: true,
                      placeholder: "",
                      label: "Number of Employees",
                    },
                    {
                      id: "business_hours_days",
                      required: false,
                      placeholder: "Business Hours",
                      label: "Business Hours and Days",
                    },
                  ],
                  [
                    {
                      id: "office_phone",
                      required: true,
                      placeholder: "Phone Number",
                      label: "Office Phone",
                    },
                    {
                      id: "fax_number",
                      required: false,
                      placeholder: "Fax",
                      label: "Fax Number",
                    },
                  ],
                  [
                    {
                      id: "direct_back_line",
                      required: false,
                      placeholder: "Line",
                      label: "Direct Back Line",
                    },
                  ],
                  [
                    {
                      id: "website_inbox",
                      required: false,
                      placeholder: "Site",
                      label: "Website/General Inbox",
                    },
                  ],
                  [
                    {
                      id: "alarm_system_code",
                      required: false,
                      placeholder: "Code",
                      label: "Tenant Alarm System Code/Key Pad Codes",
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
                <h4 className="new-tenant-form-input-group">Primary Contact</h4>
                {[
                  [
                    {
                      id: "primary_contact_first_name",
                      required: true,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "primary_contact_last_name",
                      required: true,
                      placeholder: "Name",
                      label: "Last Name",
                    },
                    {
                      id: "primary_contact_phone",
                      required: true,
                      placeholder: "Phone",
                      label: "Phone Number",
                    },
                  ],

                  [
                    {
                      id: "primary_contact_email",
                      required: true,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],
                  [
                    {
                      id: "primary_contact_checkin_method",
                      required: true,
                      type: "select",
                      options: [
                        "Email",
                        "Phone",
                        "Text",
                        "In Person",
                        "No preference",
                      ],
                      label: "Preferred Check-In Method",
                    },
                    {
                      type: "contactCheckinFrequency",
                    },
                  ],
                  [
                    {
                      type: "contactCheckboxes",
                      items: [
                        {
                          id: "primary_contact_discuss_lease",
                          type: "checkbox",
                          label:
                            "Has permission to discuss the lease and lease terms",
                        },
                        {
                          id: "primary_contact_discuss_balance",
                          type: "checkbox",
                          label: "Has permission to discuss account balance",
                        },
                        {
                          id: "primary_contact_approve_chargebacks",
                          type: "checkbox",
                          label:
                            "Has authorization to approve tenant chargebacks",
                        },
                        {
                          id: "primary_contact_receive_memos",
                          type: "checkbox",
                          label: "Should receive tenant memos",
                        },
                        {
                          id: "primary_contact_tenant_survey",
                          type: "checkbox",
                          label: "Is tenant survey contact",
                        },
                        {
                          id: "primary_contact_portal_user",
                          type: "checkbox",
                          label:
                            "Should be set up as a Tenant Portal User and Work Order Contact",
                        },
                      ],
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
                <h4 className="new-tenant-form-input-group">
                  Secondary Contact
                </h4>
                {[
                  [
                    {
                      id: "secondary_contact_first_name",
                      required: false,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "secondary_contact_last_name",
                      required: false,
                      placeholder: "Name",
                      label: "Last Name",
                    },
                    {
                      id: "secondary_contact_phone",
                      required: false,
                      placeholder: "Phone",
                      label: "Phone Number",
                    },
                  ],

                  [
                    {
                      id: "secondary_contact_email",
                      required: false,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],
                  [
                    {
                      type: "contactCheckboxes",
                      items: [
                        {
                          id: "secondary_contact_discuss_lease",
                          type: "checkbox",
                          label:
                            "Has permission to discuss the lease and lease terms",
                        },
                        {
                          id: "secondary_contact_discuss_balance",
                          type: "checkbox",
                          label: "Has permission to discuss account balance",
                        },
                        {
                          id: "secondary_contact_approve_chargebacks",
                          type: "checkbox",
                          label:
                            "Has authorization to approve tenant chargebacks",
                        },
                        {
                          id: "secondary_contact_receive_memos",
                          type: "checkbox",
                          label: "Should receive tenant memos",
                        },
                        {
                          id: "secondary_contact_tenant_survey",
                          type: "checkbox",
                          label: "Is tenant survey contact",
                        },
                        {
                          id: "secondary_contact_portal_user",
                          type: "checkbox",
                          label:
                            "Should be set up as a Tenant Portal User and Work Order Contact",
                        },
                      ],
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
              </div>
            </div>
          </div>
          <div className="new-tenant-form-section-container">
            <div className="new-tenant-form-section-column ">
              <h1 className="new-tenant-form-section-title">
                Emergency Contacts
              </h1>
              <div className="new-tenant-form-body">
                <h4 className="new-tenant-form-input-group">
                  Emergency Contact #1
                </h4>
                {[
                  [
                    {
                      id: "emergency_contact_1_first_name",
                      required: true,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "emergency_contact_1_last_name",
                      required: true,
                      placeholder: "Name",
                      label: "Last Name",
                    },
                    {
                      id: "emergency_contact_1_phone",
                      required: true,
                      placeholder: "Phone",
                      label: "Phone Number",
                    },
                  ],

                  [
                    {
                      id: "emergency_contact_1_email",
                      required: true,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
                <h4 className="new-tenant-form-input-group">
                  Emergency Contact #2
                </h4>
                {[
                  [
                    {
                      id: "emergency_contact_2_first_name",
                      required: false,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "emergency_contact_2_last_name",
                      required: false,
                      placeholder: "Name",
                      label: "Last Name",
                    },
                    {
                      id: "emergency_contact_2_phone",
                      required: false,
                      placeholder: "Phone",
                      label: "Phone Number",
                    },
                  ],

                  [
                    {
                      id: "emergency_contact_2_email",
                      required: false,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
                <h4 className="new-tenant-form-input-group">
                  Emergency Contact #3
                </h4>
                {[
                  [
                    {
                      id: "emergency_contact_3_first_name",
                      required: false,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "emergency_contact_3_last_name",
                      required: false,
                      placeholder: "Name",
                      label: "Last Name",
                    },
                    {
                      id: "emergency_contact_3_phone",
                      required: false,
                      placeholder: "Phone",
                      label: "Phone Number",
                    },
                  ],

                  [
                    {
                      id: "emergency_contact_3_email",
                      required: false,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
              </div>
            </div>
          </div>
          <div className="new-tenant-form-section-container">
            <div className="new-tenant-form-section-column">
              <h1 className="new-tenant-form-section-title">
                Billing Contact Information
              </h1>
              <div className="new-tenant-form-title-text">
                Fill out the following information for the billing contacts.
                Invoices will be sent to the emails indicated below.
              </div>
              <div className="new-tenant-form-body">
                {[
                  [
                    {
                      id: "primary_billing_contact_first_name",
                      required: true,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "primary_billing_contact_last_name",
                      required: true,
                      placeholder: "Name",
                      label: "Last Name",
                    },
                  ],
                  [
                    {
                      id: "primary_billing_contact_phone",
                      required: true,
                      placeholder: "Phone",
                      label: "Phone",
                    },
                    {
                      id: "primary_billing_contact_email",
                      required: true,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],

                  [
                    {
                      id: "primary_billing_contact_mailing_address",
                      required: true,
                      placeholder: "Address",
                      label: "Mailing Address",
                    },
                    {
                      id: "primary_billing_contact_mailing_address_city",
                      required: true,
                      placeholder: "City",
                      label: "City",
                    },
                    {
                      id: "primary_billing_contact_mailing_address_state",
                      required: true,
                      placeholder: "State",
                      label: "State",
                    },
                    {
                      id: "primary_billing_contact_mailing_address_zip",
                      required: true,
                      placeholder: "Zip",
                      label: "Zip",
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
              </div>
              <h4 className="new-tenant-form-input-group">
                Additional Billing Contact
              </h4>
              <div className="new-tenant-form-body">
                {[
                  [
                    {
                      id: "additional_billing_contact_first_name",
                      required: false,
                      placeholder: "Name",
                      label: "First Name",
                    },
                    {
                      id: "additional_billing_contact_last_name",
                      required: false,
                      placeholder: "Name",
                      label: "Last Name",
                    },

                    {
                      id: "additional_billing_contact_email",
                      required: false,
                      placeholder: "Email",
                      label: "Email",
                    },
                  ],
                ].map((row, idx) => FormInputRow(row, idx))}
              </div>
            </div>
          </div>
          {props.mode !== "Tenant Contact Commercial Cafe" && (
            <div className="new-tenant-form-section-container">
              <div className="new-tenant-form-section-column">
                <h1 className="new-tenant-form-section-title">
                  Executive Contact / Lease Signer Information
                </h1>
                <div className="new-tenant-form-title-text">
                  Fill out the following information for the executive contact
                  or lease signer.
                </div>
                <div className="new-tenant-form-body">
                  {[
                    [
                      {
                        id: "executive_contact_first_name",
                        required: true,
                        placeholder: "Name",
                        label: "First Name",
                      },
                      {
                        id: "executive_contact_last_name",
                        required: true,
                        placeholder: "Name",
                        label: "Last Name",
                      },
                    ],
                    [
                      {
                        id: "executive_contact_phone",
                        required: true,
                        placeholder: "Phone",
                        label: "Phone Number",
                      },
                      {
                        id: "executive_contact_email",
                        required: true,
                        placeholder: "Email",
                        label: "Email",
                      },
                    ],
                    [
                      {
                        id: "executive_contact_mailing_address",
                        required: true,
                        placeholder: "Address",
                        label: "Mailing Address",
                      },
                      {
                        id: "executive_contact_mailing_address_city",
                        required: true,
                        placeholder: "City",
                        label: "City",
                      },
                      {
                        id: "executive_contact_mailing_address_state",
                        required: true,
                        placeholder: "State",
                        label: "State",
                      },
                      {
                        id: "executive_contact_mailing_address_zip",
                        required: true,
                        placeholder: "Zip",
                        label: "Zip",
                      },
                    ],
                  ].map((row, idx) => FormInputRow(row, idx))}
                </div>
              </div>
            </div>
          )}
          {props.mode !== "Tenant Contact Commercial Cafe" && (
            <div className="new-tenant-form-section-container">
              <div className="new-tenant-form-section-column">
                <h1 className="new-tenant-form-section-title">
                  Insurance Contact Information
                </h1>
                <div className="new-tenant-form-title-text">
                  Fill out the following information for the primary insurance
                  contact.
                </div>
                <div className="new-tenant-form-body">
                  {[
                    [
                      {
                        id: "insurance_contact_first_name",
                        required: true,
                        placeholder: "Name",
                        label: "First Name",
                      },
                      {
                        id: "insurance_contact_last_name",
                        required: true,
                        placeholder: "Name",
                        label: "Last Name",
                      },
                    ],
                    [
                      {
                        id: "insurance_contact_phone",
                        required: true,
                        placeholder: "Phone",
                        label: "Phone Number",
                      },
                      {
                        id: "insurance_contact_email",
                        required: true,
                        placeholder: "Email",
                        label: "Email",
                      },
                    ],
                    [
                      {
                        id: "insurance_contact_mailing_address",
                        required: true,
                        placeholder: "Address",
                        label: "Mailing Address",
                      },
                      {
                        id: "insurance_contact_mailing_address_city",
                        required: true,
                        placeholder: "City",
                        label: "City",
                      },
                      {
                        id: "insurance_contact_mailing_address_state",
                        required: true,
                        placeholder: "State",
                        label: "State",
                      },
                      {
                        id: "insurance_contact_mailing_address_zip",
                        required: true,
                        placeholder: "Zip",
                        label: "Zip",
                      },
                    ],
                  ].map((row, idx) => FormInputRow(row, idx))}
                </div>
              </div>
            </div>
          )}
          {props.mode !== "Tenant Contact Commercial Cafe" && (
            <div className="new-tenant-form-section-container">
              <div className="new-tenant-form-section-column">
                <h1 className="new-tenant-form-section-title">
                  Building Directory Information
                </h1>
                <div className="new-tenant-form-title-text">
                  Type your request exactly as you’d like it to appear on the
                  Directory Board. Use upper and lower case letters, leave space
                  between words, and include appropriate punctuation.
                </div>
                <div className="new-tenant-form-body">
                  {[
                    [
                      {
                        id: "directory_board_name",
                        required: true,
                        placeholder: "Name",
                        label: "Directory Board Name",
                      },
                    ],
                  ].map((row, idx) => FormInputRow(row, idx))}
                </div>
              </div>
            </div>
          )}
          {props.mode === "New Tenant" && (
            <div className="new-tenant-form-section-container">
              <div className="new-tenant-form-section-column">
                <h1 className="new-tenant-form-section-title">
                  Key Request Info
                </h1>
                <div className="new-tenant-form-title-text">
                  Indicate the number of keys required for each key type. Please
                  note that there is a $5.00 replacement cost for lost keys.
                  <br />
                </div>
                <div className="new-tenant-form-body">
                  {[
                    [
                      {
                        id: "key_request_suite_master",
                        required: false,
                        placeholder: "Suite Master",
                        label: "Suite Master",
                      },
                      {
                        id: "key_request_front_door_only",
                        required: false,
                        placeholder: "Front Door Only",
                        label: "Front Door Only",
                      },
                    ],
                    [
                      {
                        id: "key_request_mailbox",
                        required: false,
                        placeholder: "Mailbox",
                        label: "Mailbox",
                      },
                      {
                        id: "key_request_office",
                        required: false,
                        placeholder: "Office",
                        label: "Office",
                      },
                    ],
                    [
                      {
                        id: "key_request_access_card",
                        required: false,
                        placeholder: "Other or Access Card",
                        label: "Access Card or Other",
                      },
                      {
                        id: "key_request_location_of_other",
                        required: false,
                        placeholder: "Location",
                        label: "Location for Other",
                      },
                    ],
                  ].map((row, idx) => FormInputRow(row, idx))}
                </div>
              </div>
            </div>
          )}
          {props.mode === "New Tenant" && (
            <div className="new-tenant-form-section-container ">
              <div className="new-tenant-form-section-column">
                <h1 className="new-tenant-form-section-title">
                  Welcome Board Request
                </h1>
                <div className="new-tenant-form-title-text">
                  Welltower is happy to provide a Welcome Board to announce you
                  moving into our building. In the text box below, please
                  provide a short introduction about your company and any
                  additional information. Use the Upload button to attach your
                  company logo in PNG format. A proof will be sent to the email
                  address listed.
                </div>
                <div className="new-tenant-form-body">
                  <div
                    className="contactFormInput"
                    style={{ padding: "0px 8px" }}
                  >
                    <label htmlFor="welcome_board_practice_information">
                      Practice Information
                    </label>
                    <Field
                      type="text"
                      name="welcome_board_practice_information"
                      placeholder="Practice information for welcome board"
                    >
                      {({ field, form }: any) => (
                        <textarea
                          {...field}
                          className={
                            form.errors["welcome_board_practice_information"] &&
                            form.touched["welcome_board_practice_information"]
                              ? "text-input error"
                              : "text-input"
                          }
                          style={{ borderRadius: inputBorderRadius }}
                        />
                      )}
                    </Field>

                    <Errors f="welcome_board_practice_information" {...props} />
                  </div>
                  {[
                    [
                      {
                        id: "welcome_board_name",
                        required: false,
                        placeholder: "Name",
                        label: "Name",
                      },
                      {
                        id: "welcome_board_email",
                        required: false,
                        placeholder: "Email",
                        label: "Email",
                      },
                    ],
                  ].map((row, idx) => FormInputRow(row, idx))}
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    {/*[
                    {
                      id: "welcome_board_request_logo.name",
                      required: false,
                      placeholder: "Logo",
                      label: "Logo",
                    },
                  ].map(TextInput)*/}

                    <div
                      className="contactFormInput"
                      style={{ flexGrow: 2, padding: "0px 8px" }}
                    >
                      <label htmlFor={"welcome_board_request_logo"}>Logo</label>

                      <FileUploadButton
                        id={"welcome_board_request_logo"}
                        btnLabel={"Upload"}
                        accepted={acceptedLogos}
                        onAccepted={setAcceptedLogos}
                        {...props}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="contactFormButton">
            {/*
            Nobody has complained, but a reset button is already archaic, and downright dangerous on a form this long.
            <button
              type="button"
              className="resetButton bk-button"
              onClick={handleReset}
              disabled={!dirty || isSubmitting}
            >
              Reset
            </button>*/}
            <button
              type="submit"
              className="contactButton bk-button"
              disabled={isSubmitting}
            >
              Submit
            </button>
          </div>
          {isSubmitting && <AbsoluteLoadingOverlay />}
        </form>
      )}
    </div>
  );
};

const postData = (url: string, data: any) => {
  // Default options are marked with *
  return fetch(url, {
    body: JSON.stringify(data), // must match 'Content-Type' header
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //credentials: 'same-origin', // include, same-origin, *omit
    headers: {
      "content-type": "application/json",
    },
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, cors, *same-origin
    redirect: "follow", // *manual, follow, error
    referrer: "no-referrer", // *client, no-referrer
  }).then((response) => response.json());
};

const EnhancedForm = withFormik<TenantInfoFormProps, TenantInfoFormValues>({
  mapPropsToValues: (props: TenantInfoFormProps) => {
    return {
      new_tenant_form: props.mode === "New Tenant",
      commercial_cafe_form: props.mode === "Tenant Contact Commercial Cafe",
      property_wtweb_id: "",
      tenant_name: "",
      suite_number: "",
      business_name: "",
      employee_count: "",
      business_hours_days: "",
      office_phone: "",
      fax_number: "",
      website_inbox: "",
      alarm_system_code: "",
      direct_back_line: "",
      primary_contact_first_name: "",
      primary_contact_last_name: "",
      primary_contact_email: "",
      primary_contact_phone: "",
      primary_contact_checkin_method: "",
      primary_contact_checkin_frequency: "",
      primary_contact_checkin_frequency_other: "",
      primary_contact_discuss_lease: false,
      primary_contact_discuss_balance: false,
      primary_contact_approve_chargebacks: false,
      primary_contact_receive_memos: false,
      primary_contact_tenant_survey: false,
      primary_contact_portal_user: true,
      secondary_contact_first_name: "",
      secondary_contact_last_name: "",
      secondary_contact_email: "",
      secondary_contact_phone: "",
      secondary_contact_discuss_lease: false,
      secondary_contact_discuss_balance: false,
      secondary_contact_approve_chargebacks: false,
      secondary_contact_receive_memos: false,
      secondary_contact_tenant_survey: false,
      secondary_contact_portal_user: false,

      emergency_contact_1_first_name: "",
      emergency_contact_1_last_name: "",
      emergency_contact_1_phone: "",
      emergency_contact_1_email: "",
      emergency_contact_2_first_name: "",
      emergency_contact_2_last_name: "",
      emergency_contact_2_phone: "",
      emergency_contact_2_email: "",
      emergency_contact_3_first_name: "",
      emergency_contact_3_last_name: "",
      emergency_contact_3_phone: "",
      emergency_contact_3_email: "",

      directory_board_name: "",

      primary_billing_contact_first_name: "",
      primary_billing_contact_last_name: "",
      primary_billing_contact_phone: "",
      primary_billing_contact_email: "",
      primary_billing_contact_mailing_address: "",
      additional_billing_contact_first_name: "",
      additional_billing_contact_last_name: "",
      additional_billing_contact_email: "",

      executive_contact_first_name: "",
      executive_contact_last_name: "",
      executive_contact_phone: "",
      executive_contact_email: "",
      executive_contact_mailing_address: "",

      insurance_contact_first_name: "",
      insurance_contact_last_name: "",
      insurance_contact_phone: "",
      insurance_contact_email: "",
      insurance_contact_mailing_address: "",

      key_request_suite_master: "",
      key_request_front_door_only: "",
      key_request_mailbox: "",
      key_request_office: "",
      key_request_access_card: "",
      key_request_location_of_other: "",

      welcome_board_practice_information: "",
      welcome_board_request_logo: "",
      welcome_board_name: "",
      welcome_board_email: "",
    };
  },
  /* Building a Yup schema with a cyclic dependency and the noSortEdges "escape hatch" worked in Chrome, but somehow blew up in IE.
    I tried to figure it out, but eventually had to give up and write a simple custom validation.
     */
  validate: (values: any, props) => {
    let errors: any = {};

    // copied from yup https://raw.githubusercontent.com/jquense/yup/cd407f53cadd2c94fab55c3c2d536245ac7c7919/src/string.js
    const rEmail =
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-line

    // Really basic 10-digit validation
    const rPhone = /^\D*\d{3}\D*\d{3}\D*\d{4}\D*$/;

    if (!values.property_wtweb_id || !values.property_wtweb_id.value) {
      errors.property_wtweb_id = "Please choose your Office Address";
    }

    [
      { id: "property_wtweb_id", name: "Office Address" },
      { id: "tenant_name", name: "Tenant Name" },
      { id: "suite_number", name: "Suite" },
      { id: "business_name", name: "Business Name" },
      { id: "employee_count", name: "Number of Employees" },
      { id: "office_phone", name: "Phone Number" },
      { id: "website_inbox", name: "Website or Inbox" },
      { id: "primary_contact_first_name", name: "First Name" },
      { id: "primary_contact_last_name", name: "Last Name" },
      { id: "primary_contact_email", name: "Email" },
      { id: "primary_contact_phone", name: "Phone Number" },
      // contact checkboxes or secondary contact not required

      { id: "emergency_contact_1_first_name", name: "First Name" },
      { id: "emergency_contact_1_last_name", name: "Last Name" },
      { id: "emergency_contact_1_phone", name: "Phone Number" },
      { id: "emergency_contact_1_email", name: "Email" },
      { id: "primary_billing_contact_first_name", name: "First Name" },
      { id: "primary_billing_contact_last_name", name: "Last Name" },
      { id: "primary_billing_contact_phone", name: "Phone Number" },
      { id: "primary_billing_contact_email", name: "Email" },
      {
        id: "primary_billing_contact_mailing_address",
        name: "Mailing Address",
      },
      {
        id: "primary_billing_contact_mailing_address_city",
        name: "City",
      },
      {
        id: "primary_billing_contact_mailing_address_state",
        name: "State",
      },
      {
        id: "primary_billing_contact_mailing_address_zip",
        name: "Zip",
      },
      { id: "primary_contact_checkin_method", name: "Check-In Method" },
      { id: "primary_contact_checkin_frequency", name: "Check-In Frequency" },
    ]
      .filter((field) => !values[field.id])
      .forEach((field) => (errors[field.id] = `${field.name} Required`));

    if (props.mode !== "Tenant Contact Commercial Cafe") {
      [
        { id: "directory_board_name", name: "Name" },
        { id: "executive_contact_first_name", name: "First Name" },
        { id: "executive_contact_last_name", name: "Last Name" },
        { id: "executive_contact_phone", name: "Phone Number" },
        { id: "executive_contact_email", name: "Email" },
        {
          id: "executive_contact_mailing_address",
          name: "Mailing Address",
        },
        {
          id: "executive_contact_mailing_address_city",
          name: "City",
        },
        {
          id: "executive_contact_mailing_address_state",
          name: "State",
        },
        {
          id: "executive_contact_mailing_address_zip",
          name: "Zip",
        },
        { id: "insurance_contact_first_name", name: "First Name" },
        { id: "insurance_contact_last_name", name: "Last Name" },
        { id: "insurance_contact_phone", name: "Phone Number" },
        { id: "insurance_contact_email", name: "Email" },
        {
          id: "insurance_contact_mailing_address",
          name: "Mailing Address",
        },
        {
          id: "insurance_contact_mailing_address_city",
          name: "City",
        },
        {
          id: "insurance_contact_mailing_address_state",
          name: "State",
        },
        {
          id: "insurance_contact_mailing_address_zip",
          name: "Zip",
        },
      ]
        .filter((field) => !values[field.id])
        .forEach((field) => (errors[field.id] = `${field.name} Required`));
    }

    if (
      values["primary_contact_checkin_frequency"]?.value === "Other" &&
      !values["primary_contact_checkin_frequency_other"]
    ) {
      errors["primary_contact_checkin_frequency_other"] =
        `Check-In Frequency Other Required`;
    }
    if (
      values["property_wtweb_id"]?.value === "OTHER" &&
      !values["address_other"]
    ) {
      errors["address_other"] = `Office Address Required`;
    }
    if (
      values["suite_number"]?.value === "OTHER" &&
      !values["suite_number_other"]
    ) {
      errors["suite_number_other"] = `Suite Number Required`;
    }

    [
      { id: "primary_contact_email", name: "Email" },
      { id: "secondary_contact_email", name: "Email" },
      { id: "emergency_contact_1_email", name: "Email" },
      { id: "emergency_contact_2_email", name: "Email" },
      { id: "emergency_contact_3_email", name: "Email" },
      { id: "primary_billing_contact_email", name: "Email" },
      { id: "additional_billing_contact_email", name: "Email" },
      { id: "executive_contact_email", name: "Email" },
      { id: "insurance_contact_email", name: "Email" },
      { id: "welcome_board_email", name: "Email" },
    ]
      .filter((field) => values[field.id])
      .filter((field) => !rEmail.test(values[field.id]))
      .forEach((field) => (errors[field.id] = "Invalid Email Address"));
    //if (
    //  values.referral_contact_email &&
    //  !rEmail.test(values.referral_contact_email)
    //) {
    //  errors.referral_contact_email = "Invalid email address";
    //}

    [
      { id: "office_phone", name: "Phone Number" },
      { id: "primary_contact_phone", name: "Phone Number" },
      { id: "secondary_contact_phone", name: "Phone Number" },
      { id: "emergency_contact_1_phone", name: "Phone Number" },
      { id: "emergency_contact_2_phone", name: "Phone Number" },
      { id: "emergency_contact_3_phone", name: "Phone Number" },
      { id: "primary_billing_contact_phone", name: "Phone Number" },
      { id: "executive_contact_phone", name: "Phone Number" },
      { id: "insurance_contact_phone", name: "Phone Number" },
    ]
      .filter((field) => values[field.id])
      .filter((field) => !rPhone.test(values[field.id]))
      .forEach((field) => (errors[field.id] = "Invalid Phone Number"));

    return errors;
  },

  handleSubmit: async (values, { props, setSubmitting }) => {
    const payload = {
      ...values,
      property_wtweb_id:
        values.property_wtweb_id && values.property_wtweb_id.value,
      suite_number: values.suite_number?.value,
      primary_contact_checkin_method:
        values.primary_contact_checkin_method &&
        values.primary_contact_checkin_method.value,
      primary_contact_checkin_frequency:
        values.primary_contact_checkin_frequency &&
        values.primary_contact_checkin_frequency.value,
    };
    if (
      payload.welcome_board_request_logo &&
      _.isArray(payload.welcome_board_request_logo)
    ) {
      const file = payload.welcome_board_request_logo[0];
      const b64file = await toBase64(file);
      payload.welcome_board_request_logo = {
        contentType: file.type,
        size: file.size,
        name: file.name,
        base64: b64file,
      };
    }
    postData(`${API_BASE_API}newTenantForm`, payload)
      .then((data) => {
        props.captureResult(data.msg);
        setSubmitting(false);
        //        props.closeModal && props.closeModal();
      })
      .catch((error) => {
        console.error(error);
        sendError(error);
        props.captureResult("An error has occurred. Please try again later.");
        setSubmitting(false);
      });
  },
  displayName: "TenantInfoForm", // helps with React DevTools
})(TenantInfoForm);

const TenantInfoFormWrapper = (props: TenantInfoFormWrapperProps) => {
  const [submissionResult, setSubmissionResult] = useState<string>();
  return (
    <EnhancedForm
      {...props}
      captureResult={setSubmissionResult}
      submissionResult={submissionResult}
    />
  );
};

const TenantInfoFormPage = (props: TenantInfoFormPageProps) => (
  <>
    <Helmet>
      {/* This should get title and description from the Helmet in App.js */}
      <title>
        Welltower Medical Office -{" "}
        {props.mode === "New Tenant" ? "New Tenants" : "Tenant Contact Form"}
      </title>
      <link
        rel="canonical"
        href={absoluteUrl(
          props.mode === "New Tenant"
            ? "/new-tenant"
            : props.mode === "Tenant Contact"
              ? "/tenant-contact"
              : "/tenant-contact-cc",
        )}
      />
    </Helmet>

    <Box mt={12} pt={"75px"} paddingBottom={10}>
      <Container maxW={["100%", "70%"]}>
        <Card mb={10} boxShadow="0px 0px 20px 0px #0000001A">
          <CardBody pt={50} px={50} pb={30}>
            <TenantInfoFormWrapper {...props} />
          </CardBody>
        </Card>
      </Container>
    </Box>
  </>
);

export default TenantInfoFormPage;
